// PureValidator: "0x1716898d72BE098F4828B435a3918cBFda562Efc",
// PureSafeMath: "0x850c7E3eBf05d0A617DAe4beE14A4A5C03CAb9da",
export var supportedContracts = [];
